import React, { useEffect, useState } from "react";
import { useTheme } from "../ThemeContext";
import { useNavigate } from "react-router-dom";

const SUBCATEGORIES: Record<string, string[]> = {
  "Electrical": ["Panel Upgrade", "Outlet Installation", "Lighting", "Ceiling Fan", "EV Charger", "Smart Home Wiring", "Generator Install"],
  "Plumbing": ["Leak Repair", "Pipe Installation", "Drain Cleaning", "Water Heater", "Toilet Repair", "Fixture Install", "Emergency Plumbing"],
  "Cleaning": ["Standard Cleaning", "Deep Cleaning", "Move In/Out", "Airbnb Cleaning", "Office Cleaning", "Carpet Cleaning", "Window Cleaning"],
  "Outdoor": ["Lawn Mowing", "Garden Design", "Tree Trimming", "Irrigation", "Sod Installation", "Mulching", "Leaf Removal"],
  "Painting": ["Interior Painting", "Exterior Painting", "Cabinet Painting", "Deck Staining", "Wallpaper", "Faux Finishing"],
  "Moving": ["Local Moving", "Long Distance", "Furniture Assembly", "Furniture Delivery", "Junk Removal", "Packing", "Office Moving"],
  "Additions/Remodels": ["Room Addition", "Basement Remodeling", "Attic Conversion", "Garage Conversion", "Sunroom Addition"],
  "Air Conditioning": ["AC Installation", "AC Repair", "AC Maintenance", "Duct Cleaning", "Smart Thermostat", "Ventilation"],
  "Bathroom Remodeling": ["Full Remodel", "Shower Installation", "Bathtub Install", "Vanity Install", "Tile Work", "Fixtures"],
  "Cabinets": ["Cabinet Installation", "Cabinet Refacing", "Custom Cabinets", "Cabinet Painting", "Kitchen Cabinets"],
  "Carpentry": ["Custom Furniture", "Trim & Molding", "Door Installation", "Staircase Work", "Wood Repair", "Built-in Shelving"],
  "Concrete & Masonry": ["Concrete Pouring", "Driveway Repair", "Brick Laying", "Retaining Walls", "Walkway Install"],
  "Decks & Patios": ["Deck Building", "Deck Repair", "Patio Install", "Pergola Building", "Screened Porch", "Deck Staining"],
  "Drywall": ["Drywall Install", "Drywall Repair", "Insulation", "Texture Application", "Soundproofing"],
  "Fences": ["Wood Fence", "Vinyl Fence", "Chain Link", "Iron Fence", "Fence Repair", "Gate Installation"],
  "Flooring": ["Hardwood", "Laminate", "Tile Flooring", "Carpet Install", "Vinyl Flooring", "Floor Refinishing"],
  "Heating & HVAC": ["Furnace Install", "Furnace Repair", "Boiler Service", "Heat Pump", "Radiant Heating", "Fireplace"],
  "Kitchen Remodeling": ["Full Remodel", "Cabinet Install", "Countertop", "Appliances", "Backsplash", "Kitchen Island"],
  "Home Theater": ["TV Mounting", "Surround Sound", "Projector Setup", "Home Theater Design", "Cable Management"],
  "Swimming Pools": ["Pool Installation", "Pool Repair", "Pool Cleaning", "Hot Tub Install", "Sauna Install"],
  "Tile & Stone": ["Floor Tile", "Wall Tile", "Backsplash", "Shower Tile", "Grout Repair", "Natural Stone"],
  "Windows & Doors": ["Window Install", "Window Repair", "Door Install", "Door Repair", "Sliding Doors", "Storm Doors"],
  "Roofing": ["Roof Replacement", "Roof Repair", "Gutter Install", "Gutter Cleaning", "Skylight Install"],
  "Home Inspection": ["Home Inspection", "Pre-Purchase", "Mold Inspection", "Pest Inspection", "Roof Inspection"],
  "Green Home": ["Solar Install", "Rainwater Harvesting", "Green Insulation", "Eco Flooring", "Low-VOC Painting"],
};

const ALL_CATEGORIES = [
  { icon: "⚡", label: "Electrical", color: "#F5A623" },
  { icon: "🔧", label: "Plumbing", color: "#0E8C6A" },
  { icon: "🧹", label: "Cleaning", color: "#1A3CE8" },
  { icon: "🌿", label: "Outdoor", color: "#16A34A" },
  { icon: "🎨", label: "Painting", color: "#7C3AED" },
  { icon: "🚚", label: "Moving", color: "#DC2626" },
  { icon: "🏗️", label: "Additions/Remodels", color: "#0D1B3E" },
  { icon: "❄️", label: "Air Conditioning", color: "#06B6D4" },
  { icon: "🚿", label: "Bathroom Remodeling", color: "#8B5CF6" },
  { icon: "🗄️", label: "Cabinets", color: "#92400E" },
  { icon: "🪵", label: "Carpentry", color: "#78350F" },
  { icon: "🧱", label: "Concrete & Masonry", color: "#6B7280" },
  { icon: "🏡", label: "Decks & Patios", color: "#065F46" },
  { icon: "🏠", label: "Drywall", color: "#9CA3AF" },
  { icon: "🚧", label: "Fences", color: "#B45309" },
  { icon: "🪵", label: "Flooring", color: "#92400E" },
  { icon: "🔥", label: "Heating & HVAC", color: "#DC2626" },
  { icon: "🍳", label: "Kitchen Remodeling", color: "#D97706" },
  { icon: "📺", label: "Home Theater", color: "#4F46E5" },
  { icon: "🏊", label: "Swimming Pools", color: "#0284C7" },
  { icon: "🪨", label: "Tile & Stone", color: "#6B7280" },
  { icon: "🚪", label: "Windows & Doors", color: "#0D1B3E" },
  { icon: "🏠", label: "Roofing", color: "#7C3AED" },
  { icon: "🔍", label: "Home Inspection", color: "#059669" },
  { icon: "♻️", label: "Green Home", color: "#16A34A" },
];

export default function LandingPage() {
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);
  const { toggleTheme, isDark } = useTheme();
  const [showAllServices, setShowAllServices] = useState(false);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [featuredPros, setFeaturedPros] = useState<any[]>([]);

  useEffect(() => {
    fetch("https://uofc7ezzuk.execute-api.us-east-1.amazonaws.com/public/featured-pros")
      .then(r => r.json())
      .then(data => setFeaturedPros(data.pros || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: "#FAFAFA", color: "#0D1B3E", overflowX: "hidden" }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .svc-btn:hover { transform: translateY(-6px) !important; }
        .cta-outline:hover { background: #0D1B3E !important; color: white !important; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: none; } }
      `}</style>

      {/* Nav */}
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        background: scrollY > 50 ? "rgba(255,255,255,0.96)" : "transparent",
        backdropFilter: scrollY > 50 ? "blur(20px)" : "none",
        borderBottom: scrollY > 50 ? "1px solid rgba(0,0,0,0.06)" : "none",
        transition: "all 0.3s ease", padding: "0 5%",
        display: "flex", alignItems: "center", justifyContent: "space-between", height: "70px",
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <svg width="52" height="52" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="lg1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#4C6EF5"/><stop offset="100%" stopColor="#1A3CE8"/></linearGradient>
              <linearGradient id="lg2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#20C997"/><stop offset="100%" stopColor="#0E8C6A"/></linearGradient>
              <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3B5BDB"/><stop offset="100%" stopColor="#0E8C6A"/></linearGradient>
            </defs>
            <rect width="52" height="52" rx="14" fill="url(#bgGrad)"/>
            <g transform="translate(4,5)">
              <path d="M11,0 C4.9,0 0,4.9 0,11 C0,17.1 11,28 11,28 C11,28 22,17.1 22,11 C22,4.9 17.1,0 11,0 Z" fill="white" opacity="0.95"/>
              <circle cx="11" cy="10" r="5" fill="url(#lg1)"/>
              <circle cx="11" cy="10" r="2.5" fill="white"/>
            </g>
            <g transform="translate(25,5)">
              <path d="M11,0 C4.9,0 0,4.9 0,11 C0,17.1 11,28 11,28 C11,28 22,17.1 22,11 C22,4.9 17.1,0 11,0 Z" fill="white" opacity="0.85"/>
              <circle cx="11" cy="10" r="5" fill="url(#lg2)"/>
              <circle cx="11" cy="10" r="2.5" fill="white"/>
            </g>
            
          </svg>
          <span style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem', fontWeight: 700, color: scrollY > 50 ? '#0D1B3E' : 'white', letterSpacing: '-0.5px' }}>Mouna</span>
        </div>
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <button onClick={() => navigate("/login")}
            style={{ background: "transparent", border: "none", cursor: "pointer", fontWeight: 600, fontSize: "0.875rem", color: scrollY > 50 ? "#0D1B3E" : "rgba(255,255,255,0.85)", padding: "8px 16px" }}>
            Sign In
          </button>
          <button onClick={toggleTheme}
            style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "50%", width: "38px", height: "38px", cursor: "pointer", fontSize: "1rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {isDark ? "☀️" : "🌙"}
          </button>
          <button onClick={() => navigate("/login")}
            style={{ background: "#1A3CE8", color: "white", border: "none", borderRadius: "100px", padding: "10px 24px", fontWeight: 700, fontSize: "0.875rem", cursor: "pointer" }}>
            Get Started
          </button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{
        minHeight: "100vh", background: "linear-gradient(135deg, #0D1B3E 0%, #1A3CE8 58%, #0E8C6A 100%)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        padding: "120px 5% 80px", position: "relative", overflow: "hidden", textAlign: "center",
      }}>
        <div style={{ position: "absolute", inset: 0, opacity: 0.04, backgroundImage: "radial-gradient(circle, white 1.5px, transparent 1.5px)", backgroundSize: "40px 40px" }}/>
        <div style={{ position: "absolute", width: "500px", height: "500px", borderRadius: "50%", background: "rgba(14,140,106,0.25)", filter: "blur(100px)", top: "-150px", right: "-150px" }}/>
        <div style={{ position: "absolute", width: "400px", height: "400px", borderRadius: "50%", background: "rgba(245,166,35,0.15)", filter: "blur(80px)", bottom: "-100px", left: "-100px" }}/>

        <div style={{ position: "relative", maxWidth: "760px" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            background: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.2)", borderRadius: "100px",
            padding: "8px 20px", marginBottom: "32px",
            color: "white", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.1em",
          }}>
            <div style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#0E8C6A" }}/>
           HOUSTON HOME SERVICES MARKETPLACE
          </div>

          <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(2.8rem, 8vw, 5.5rem)",
            fontWeight: 700, lineHeight: 1.05, color: "white", marginBottom: "24px",
          }}>
            Your home,<br/>
            <em style={{ fontStyle: "italic", color: "#F5A623" }}>perfectly</em> cared for.
          </h1>

          <p style={{ fontSize: "1.125rem", color: "rgba(255,255,255,0.72)", lineHeight: 1.7, maxWidth: "520px", margin: "0 auto 48px" }}>
           Browse Houston-local pros for electrical, plumbing, cleaning, and more. Pick the one you want and book.
          </p>

          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/login")}
              style={{ background: "white", color: "#1A3CE8", border: "none", borderRadius: "100px", padding: "18px 44px", fontWeight: 700, fontSize: "1rem", cursor: "pointer", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
              Book a Service →
            </button>
            <button onClick={() => navigate("/pro-signup")}
              style={{ background: "rgba(255,255,255,0.1)", color: "white", border: "1px solid rgba(255,255,255,0.3)", borderRadius: "100px", padding: "18px 44px", fontWeight: 600, fontSize: "1rem", cursor: "pointer", backdropFilter: "blur(10px)" }}>
              Join as a Pro
            </button>
          </div>
          <div style={{ marginTop: "20px" }}>
            <button onClick={() => navigate("/browse")}
              style={{ background: "transparent", color: "rgba(255,255,255,0.85)", border: "none", textDecoration: "underline", textUnderlineOffset: "4px", fontSize: "0.95rem", fontWeight: 500, cursor: "pointer" }}>
              Browse all services →
            </button>
          </div>
        </div>
      </div>

    

      {/* Trust Badges */}
      <div style={{ background: "white", padding: "60px 5%", borderBottom: "1px solid #F3F4F6" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "12px" }}>WHY CHOOSE MOUNA</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(1.75rem, 4vw, 2.5rem)", fontWeight: 700, lineHeight: 1.2, color: "#0D1B3E" }}>
           Honest, local, transparent
            </h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" }}>
            {[
              { icon: "\ud83d\udccd", title: "Houston-Local Pros", desc: "Local professionals who actually work in your neighborhood. No call centers, no outsourcing.", color: "#0E8C6A" },
              { icon: "\ud83d\udcb5", title: "Pay Your Pro Directly", desc: "Mouna doesn't process payments. You pay your pro after the job, just like a trusted local handyman.", color: "#1A3CE8" },
              { icon: "\ud83d\udee1\ufe0f", title: "Quote Before Work Begins", desc: "Your pro confirms an exact price after you book, before any work starts.", color: "#F5A623" },
              { icon: "\ud83c\udfe0", title: "Free for Clients", desc: "Browse pros, read reviews, and book at no cost. Mouna charges clients nothing.", color: "#7C3AED" },
            ].map(badge => (
              <div key={badge.title} style={{
                background: "white", border: "1px solid #F3F4F6", borderRadius: "20px",
                padding: "28px 24px", textAlign: "center",
              }}>
                <div style={{
                  width: "56px", height: "56px", borderRadius: "16px",
                  background: badge.color + "15", color: badge.color,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "1.75rem", fontWeight: 700, margin: "0 auto 16px",
                }}>{badge.icon}</div>
                <div style={{ fontWeight: 700, fontSize: "1rem", marginBottom: "8px", color: "#0D1B3E" }}>{badge.title}</div>
                <div style={{ color: "#6B7280", fontSize: "0.875rem", lineHeight: 1.5 }}>{badge.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Services */}
      <div style={{ padding: "100px 5%", textAlign: "center", background: "white" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto" }}>
          <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>WHAT WE OFFER</div>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 5vw, 3.5rem)", fontWeight: 700, marginBottom: "16px", lineHeight: 1.2 }}>
            Every service your home needs
          </h2>
          <p style={{ color: "#6B7280", fontSize: "1.0625rem", margin: "0 auto 64px", maxWidth: "480px" }}>
           From quick fixes to full renovations — Houston-local pros for every category.
          </p>
          {/* Horizontal Category Slider */}
          <div style={{ overflowX: "auto", scrollSnapType: "x mandatory", display: "flex", gap: "10px", paddingBottom: "12px", scrollbarWidth: "none", msOverflowStyle: "none", WebkitOverflowScrolling: "touch" }}>
            {ALL_CATEGORIES.map(svc => {
              const isActive = activeCategory === svc.label;
              return (
                <button key={svc.label}
                  onClick={() => setActiveCategory(isActive ? null : svc.label)}
                  style={{
                    scrollSnapAlign: "start", flexShrink: 0,
                    display: "flex", alignItems: "center", gap: "8px",
                    padding: "10px 20px", borderRadius: "100px", cursor: "pointer",
                    border: isActive ? "none" : "2px solid #E5E7EB",
                    background: isActive ? `linear-gradient(135deg, ${svc.color}, ${svc.color}CC)` : "white",
                    color: isActive ? "white" : "#0D1B3E",
                    fontWeight: 700, fontSize: "0.875rem",
                    transition: "all 0.2s ease",
                    boxShadow: isActive ? `0 4px 16px ${svc.color}44` : "none",
                    transform: isActive ? "translateY(-2px)" : "none",
                  }}>
                  <span style={{ fontSize: "1.125rem" }}>{svc.icon}</span>
                  <span>{svc.label}</span>
                  <span style={{ fontSize: "0.75rem", opacity: 0.8 }}>{isActive ? "▲" : "▾"}</span>
                </button>
              );
            })}
          </div>

          {/* Expandable subcategory panel */}
          {activeCategory && (() => {
            const cat = ALL_CATEGORIES.find(c => c.label === activeCategory);
            const subcats = SUBCATEGORIES[activeCategory] || [];
            return cat ? (
              <div style={{
                background: "white", border: `2px solid ${cat.color}33`,
                borderRadius: "20px", padding: "24px", marginTop: "8px",
                animation: "fadeIn 0.2s ease",
                boxShadow: `0 8px 32px ${cat.color}15`,
              }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ width: "40px", height: "40px", borderRadius: "12px", background: `${cat.color}18`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.375rem" }}>{cat.icon}</div>
                    <div>
                      <div style={{ fontWeight: 700, color: "#0D1B3E" }}>{cat.label}</div>
                      <div style={{ fontSize: "0.75rem", color: "#6B7280" }}>{subcats.length} services available</div>
                    </div>
                  </div>
                  <button onClick={() => {
                    const slug = cat.label.toLowerCase().replace(/[^a-z]/g, "");
                    navigate(`/services/${slug}`);
                  }}
                    style={{ background: cat.color, color: "white", border: "none", borderRadius: "100px", padding: "8px 20px", fontWeight: 700, fontSize: "0.8125rem", cursor: "pointer" }}>
                    Learn More →
                  </button>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {subcats.map((sub: string) => (
                    <button key={sub} onClick={() => {
                      const slug = cat.label.toLowerCase().replace(/[^a-z]/g, "");
                      navigate(`/services/${slug}`);
                    }}
                      style={{ background: `${cat.color}10`, color: cat.color, border: `1px solid ${cat.color}30`, borderRadius: "100px", padding: "6px 14px", fontSize: "0.8125rem", fontWeight: 600, cursor: "pointer", transition: "all 0.15s" }}
                      onMouseEnter={e => { const b = e.currentTarget as HTMLElement; b.style.background = cat.color; b.style.color = "white"; }}
                      onMouseLeave={e => { const b = e.currentTarget as HTMLElement; b.style.background = `${cat.color}10`; b.style.color = cat.color; }}>
                      {sub}
                    </button>
                  ))}
                </div>
              </div>
            ) : null;
          })()}
          <div style={{ marginTop: "48px" }}>
            <button onClick={() => setShowAllServices(!showAllServices)}
              style={{ background: showAllServices ? "#0D1B3E" : "transparent", color: showAllServices ? "white" : "#0D1B3E", border: "2px solid #0D1B3E", borderRadius: showAllServices ? "20px 20px 0 0" : "100px", padding: "14px 40px", fontWeight: 700, cursor: "pointer", fontSize: "0.875rem", transition: "all 0.3s", width: showAllServices ? "100%" : "auto" }}>
              {showAllServices ? "Close ✕" : "Browse All Services ▾"}
            </button>
            {showAllServices && (
              <div style={{ background: "#0D1B3E", borderRadius: "0 0 24px 24px", padding: "32px", animation: "fadeIn 0.2s ease" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: "12px" }}>
                  {ALL_CATEGORIES.map(cat => (
                    <button key={cat.label}
                      onClick={() => { navigate(`/explore?category=${cat.label}`); setShowAllServices(false); }}
                      style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "16px", padding: "16px 12px", cursor: "pointer", transition: "all 0.2s", display: "flex", alignItems: "center", gap: "10px", textAlign: "left" }}
                      onMouseEnter={e => { const b = e.currentTarget as HTMLElement; b.style.background = "rgba(255,255,255,0.14)"; b.style.borderColor = cat.color; }}
                      onMouseLeave={e => { const b = e.currentTarget as HTMLElement; b.style.background = "rgba(255,255,255,0.06)"; b.style.borderColor = "rgba(255,255,255,0.1)"; }}>
                      <span style={{ fontSize: "1.5rem", flexShrink: 0 }}>{cat.icon}</span>
                      <span style={{ color: "white", fontWeight: 600, fontSize: "0.8125rem", lineHeight: 1.3 }}>{cat.label}</span>
                    </button>
                  ))}
                </div>
                <div style={{ marginTop: "24px", paddingTop: "20px", borderTop: "1px solid rgba(255,255,255,0.1)", textAlign: "center" }}>
                  <button onClick={() => navigate("/explore")}
                    style={{ background: "#1A3CE8", color: "white", border: "none", borderRadius: "100px", padding: "12px 32px", fontWeight: 700, cursor: "pointer", fontSize: "0.875rem" }}>
                    View All Pros →
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ padding: "100px 5%", background: "#F9FAFB" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "64px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>HOW IT WORKS</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: 700 }}>3 steps to a better home</h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "28px" }}>
            {[
            { step: "01", title: "Browse Houston pros", desc: "Explore pros across 25+ home service categories. Read reviews, check rates, view profiles.", icon: "🔍", color: "#EEF1FF" },
              { step: "02", title: "Book the one you want", desc: "Pick the pro who fits your job. Send your booking with photos and the details.", icon: "📋", color: "#D0F5EA" },
              { step: "03", title: "Pro confirms with a quote", desc: "Your pro accepts, confirms an exact price, and gets the work done. You pay them directly.", icon: "✅", color: "#FEF3DC" },
            ].map(item => (
              <div key={item.step} style={{ background: "white", borderRadius: "24px", padding: "40px 32px", boxShadow: "0 2px 12px rgba(0,0,0,0.05)", position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: "16px", right: "20px", fontFamily: "'Playfair Display', serif", fontSize: "4.5rem", fontWeight: 700, color: "#F3F4F6", lineHeight: 1 }}>{item.step}</div>
                <div style={{ width: "52px", height: "52px", background: item.color, borderRadius: "14px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.625rem", marginBottom: "24px" }}>{item.icon}</div>
                <h3 style={{ fontWeight: 700, fontSize: "1.1875rem", marginBottom: "12px" }}>{item.title}</h3>
                <p style={{ color: "#6B7280", lineHeight: 1.65, fontSize: "0.9375rem" }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Featured Providers */}
      {featuredPros.length > 0 && (
        <div style={{ padding: "100px 5%", background: "#F9FAFB" }}>
          <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "48px" }}>
              <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#1A3CE8", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>FEATURED PROS</div>
             <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: 700, marginBottom: "12px" }}>Featured Houston pros</h2>
              <p style={{ color: "#6B7280", fontSize: "1rem", maxWidth: "560px", margin: "0 auto" }}>Local professionals serving the Houston area.</p>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "20px" }}>
              {featuredPros.map(pro => (
                <div key={pro.proId} style={{ background: "white", borderRadius: "20px", padding: "24px", border: "1px solid #F3F4F6" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "16px" }}>
                    {pro.photoUrl ? (
                      <img src={pro.photoUrl} alt={pro.name} style={{ width: "60px", height: "60px", borderRadius: "50%", objectFit: "cover" }}/>
                    ) : (
                      <div style={{ width: "60px", height: "60px", borderRadius: "50%", background: "linear-gradient(135deg, #1A3CE8, #0E8C6A)", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 700, fontSize: "1.5rem" }}>
                        {pro.name.charAt(0)}
                      </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "2px" }}>
                        <div style={{ fontWeight: 700, fontSize: "1rem" }}>{pro.businessName || pro.name}</div>
                        {pro.verified && (
                          <span title="Verified" style={{ color: "#0E8C6A", fontSize: "0.875rem" }}>✓</span>
                        )}
                      </div>
                      <div style={{ color: "#6B7280", fontSize: "0.8125rem" }}>{pro.serviceCategory}</div>
                    </div>
                  </div>
                {pro.reviewCount > 0 ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                      <span style={{ color: "#F5A623", fontSize: "0.9375rem" }}>{"★".repeat(Math.round(pro.rating))}</span>
                      <span style={{ fontWeight: 700, fontSize: "0.875rem", color: "#0D1B3E" }}>{pro.rating.toFixed(1)}</span>
                      <span style={{ color: "#9CA3AF", fontSize: "0.8125rem" }}>({pro.reviewCount} {pro.reviewCount === 1 ? "review" : "reviews"})</span>
                    </div>
                  ) : (
                    <div style={{ marginBottom: "12px" }}>
                      <span style={{ color: "#9CA3AF", fontSize: "0.8125rem", fontWeight: 600, fontStyle: "italic" }}>New on Mouna — no reviews yet</span>
                    </div>
                  )}
                  <div style={{ color: "#4B5563", fontSize: "0.875rem", lineHeight: 1.6, marginBottom: "16px", minHeight: "40px" }}>
                    {pro.bio || "Trusted local professional ready to help."}
                  </div>
                  <button onClick={() => navigate("/login")}
                    style={{ width: "100%", background: "transparent", color: "#1A3CE8", border: "1.5px solid #1A3CE8", borderRadius: "100px", padding: "10px", fontWeight: 700, fontSize: "0.875rem", cursor: "pointer", transition: "all 0.2s" }}
                    onMouseEnter={e => { const b = e.currentTarget as HTMLElement; b.style.background = "#1A3CE8"; b.style.color = "white"; }}
                    onMouseLeave={e => { const b = e.currentTarget as HTMLElement; b.style.background = "transparent"; b.style.color = "#1A3CE8"; }}>
                    View Profile →
                  </button>
                </div>
              ))}
            </div>
            <div style={{ textAlign: "center", marginTop: "40px" }}>
              <button onClick={() => navigate("/explore")}
                style={{ background: "white", color: "#0D1B3E", border: "2px solid #0D1B3E", borderRadius: "100px", padding: "14px 32px", fontWeight: 700, fontSize: "0.875rem", cursor: "pointer" }}>
                Browse All Pros →
              </button>
            </div>
          </div>
        </div>
      )}

     
      {/* Pro CTA */}
      <div style={{ padding: "100px 5%", background: "linear-gradient(135deg, #0D1B3E, #1A3CE8)", textAlign: "center" }}>
        <div style={{ maxWidth: "580px", margin: "0 auto" }}>
          <div style={{ fontSize: "3rem", marginBottom: "24px" }}>🔨</div>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem, 5vw, 3rem)", fontWeight: 700, color: "white", marginBottom: "16px" }}>Are you a professional?</h2>
          <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "1.0625rem", marginBottom: "40px", lineHeight: 1.7 }}>
           Get real bookings from Houston clients ready to hire. Set your own rates. No subscription — pay only when you accept a job.
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/pro-signup")}
              style={{ background: "#F5A623", color: "#0D1B3E", border: "none", borderRadius: "100px", padding: "18px 44px", fontWeight: 700, fontSize: "1rem", cursor: "pointer" }}>
              Join as a Pro →
            </button>
            <button onClick={() => navigate("/explore")}
              style={{ background: "rgba(255,255,255,0.1)", color: "white", border: "1px solid rgba(255,255,255,0.3)", borderRadius: "100px", padding: "18px 44px", fontWeight: 600, fontSize: "1rem", cursor: "pointer" }}>
              Browse the Platform
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ background: "#080F20", padding: "48px 5%", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "24px" }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
              <svg width="48" height="48" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="flg1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#4C6EF5"/><stop offset="100%" stopColor="#1A3CE8"/></linearGradient>
                  <linearGradient id="flg2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#20C997"/><stop offset="100%" stopColor="#0E8C6A"/></linearGradient>
                  <linearGradient id="fbg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3B5BDB"/><stop offset="100%" stopColor="#0E8C6A"/></linearGradient>
                </defs>
                <rect width="52" height="52" rx="14" fill="url(#fbg)"/>
                <g transform="translate(4,5)">
                  <path d="M11,0 C4.9,0 0,4.9 0,11 C0,17.1 11,28 11,28 C11,28 22,17.1 22,11 C22,4.9 17.1,0 11,0 Z" fill="white" opacity="0.95"/>
                  <circle cx="11" cy="10" r="5" fill="url(#flg1)"/>
                  <circle cx="11" cy="10" r="2.5" fill="white"/>
                </g>
                <g transform="translate(25,5)">
                  <path d="M11,0 C4.9,0 0,4.9 0,11 C0,17.1 11,28 11,28 C11,28 22,17.1 22,11 C22,4.9 17.1,0 11,0 Z" fill="white" opacity="0.85"/>
                  <circle cx="11" cy="10" r="5" fill="url(#flg2)"/>
                  <circle cx="11" cy="10" r="2.5" fill="white"/>
                </g>
                
              </svg>
              <span style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.5rem', fontWeight: 700, color: 'white' }}>Mouna</span>
            </div>
            <div style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.75rem" }}>Houston's home services marketplace</div>
          </div>
          <div style={{ display: "flex", gap: "28px", flexWrap: "wrap" }}>
            {[
             { label: "About", action: () => navigate("/about") },
              { label: "Pricing", action: () => navigate("/pricing") },
              { label: "For Pros", action: () => navigate("/become-pro") },
              { label: "Contact", action: () => navigate("/contact") },
              { label: "Terms", action: () => navigate("/terms") },
              { label: "Privacy", action: () => navigate("/privacy") },
            ].map(link => (
              <span key={link.label} onClick={link.action}
                style={{ color: "rgba(255,255,255,0.45)", cursor: "pointer", fontSize: "0.875rem", transition: "color 0.2s" }}
                onMouseEnter={e => (e.currentTarget as HTMLElement).style.color = "white"}
                onMouseLeave={e => (e.currentTarget as HTMLElement).style.color = "rgba(255,255,255,0.45)"}>
                {link.label}
              </span>
            ))}
          </div>
        </div>
        <div style={{ maxWidth: "900px", margin: "28px auto 0", borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "24px", textAlign: "center" }}>
          <div style={{ color: "rgba(255,255,255,0.25)", fontSize: "0.75rem" }}>© 2026 Mouna. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}
